import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';

import Icon from 'components/Icon';
import { ButtonV3 } from 'components/ComponentV2';

import { UserActionEnum } from 'hooks/useOpportunity/useOpportunityInternal';
import { useOpportunity } from 'lib/providers/OpportunityProvider';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useCommonList } from 'lib/contexts/common-list-context';
import styles from './OnboardingBanner.module.scss';

export const OnboardingBanner = ({ className }: { className?: string }) => {
  const [t] = useTranslation('opportunity');
  const { updateUserAction } = useOpportunity();
  const {
    configData: { opportunity_count, company_count },
    isConfigDataLoading,
  } = useCommonList();

  const onClickStarted = useCallback(() => {
    updateUserAction({ userAction: UserActionEnum.REDIRECT_TO, userActionURL: PAGE_ROUTES.AI_SEARCH });
  }, []);

  if (isConfigDataLoading) return null;

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.content}>
        <Icon iconName="icon_briefcase" size="mediumplus" />
        <p className={styles.title}>{t('onboarding-external-jobs.title', { opportunity_count, company_count })}</p>
        <ButtonV3 className={styles['btn']} variant="contained" color="primary" size="small" borderless onClick={onClickStarted}>
          {t('onboarding-external-jobs.cta')}
        </ButtonV3>
      </div>
    </div>
  );
};

OnboardingBanner.displayName = 'OnboardingBanner';
